var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1507_102)","key":0},React.createElement("path",{"d":"M5.2001 2.34998L10.9001 8.04998L5.2001 13.75","stroke":"white","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1507_102"},React.createElement("rect",{"width":"7.2","height":"12.9","fill":"white","transform":"translate(4.4001 1.54999)"})))]);
}

Chevron.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Chevron;

Chevron.default = Chevron;
